// KOBEミナトマチカレー メニュー・価格 データ（単一の情報源）
// 2026年8月版メニューポスターより転記。
// 「要確認」の項目は未確定のため、そのまま公開しないでください。

export type SizePrice = {
  base: number; // 本体価格
  tax: number; // 税込価格
};

export type CurryItem = {
  no: number;
  name: string; // 表示用（改行は "\n" で制御）
  nameEn?: string;
  nameCn?: string;
  badge?: string; // ポスター記載のフラグ文言（実データ）
  spiceLevel: null; // 要確認：辛さ表記はポスターに記載なし
  sizes: {
    S: SizePrice;
    R: SizePrice;
    L: SizePrice;
  };
};

// ご飯の量（サイズ共通）
export const RICE_SIZE = {
  S: "180g",
  R: "250g",
  L: "330g",
};

// カレー全15種類（ポスター記載順）
export const CURRY_MENU: CurryItem[] = [
  {
    no: 1,
    name: "神戸ミナトマチカレー",
    nameEn: "Kobe Minatomachi Curry",
    badge: "人気No.1",
    spiceLevel: null,
    sizes: { S: { base: 830, tax: 913 }, R: { base: 880, tax: 968 }, L: { base: 980, tax: 1078 } },
  },
  {
    no: 2,
    name: "甘口ポークカレー",
    nameEn: "Mild Pork Curry",
    badge: "やさしい甘口",
    spiceLevel: null,
    sizes: { S: { base: 830, tax: 913 }, R: { base: 880, tax: 968 }, L: { base: 980, tax: 1078 } },
  },
  {
    no: 3,
    name: "濃厚玉子カレー",
    nameEn: "Rich Egg Curry",
    badge: "まろやか濃厚",
    spiceLevel: null,
    sizes: { S: { base: 930, tax: 1023 }, R: { base: 980, tax: 1078 }, L: { base: 1080, tax: 1188 } },
  },
  {
    no: 4,
    name: "濃厚チーズカレー",
    nameEn: "Rich Cheese Curry",
    spiceLevel: null,
    sizes: { S: { base: 930, tax: 1023 }, R: { base: 980, tax: 1078 }, L: { base: 1080, tax: 1188 } },
  },
  {
    no: 5,
    name: "ソーセージカレー",
    nameEn: "Sausage Curry",
    badge: "パリッと！",
    spiceLevel: null,
    sizes: { S: { base: 1030, tax: 1133 }, R: { base: 1080, tax: 1188 }, L: { base: 1180, tax: 1298 } },
  },
  {
    no: 6,
    name: "チキンカツカレー",
    nameEn: "Chicken Cutlet Curry",
    badge: "人気No.2",
    spiceLevel: null,
    sizes: { S: { base: 1030, tax: 1133 }, R: { base: 1080, tax: 1188 }, L: { base: 1180, tax: 1298 } },
  },
  {
    no: 7,
    name: "神戸名物ぼっかけカレー",
    nameEn: "Beef Tendon Curry",
    badge: "神戸名物",
    spiceLevel: null,
    sizes: { S: { base: 1130, tax: 1243 }, R: { base: 1180, tax: 1298 }, L: { base: 1280, tax: 1408 } },
  },
  {
    no: 8,
    name: "海老フライカレー",
    nameEn: "Fried Shrimp Curry",
    spiceLevel: null,
    sizes: { S: { base: 1180, tax: 1298 }, R: { base: 1230, tax: 1353 }, L: { base: 1330, tax: 1463 } },
  },
  {
    no: 9,
    name: "唐揚げカレー",
    nameEn: "Japanese Fried Chicken Curry",
    spiceLevel: null,
    sizes: { S: { base: 1230, tax: 1353 }, R: { base: 1280, tax: 1408 }, L: { base: 1380, tax: 1518 } },
  },
  {
    no: 10,
    name: "名物ハンバーグカレー",
    nameEn: "Signature Hamburger Steak Curry",
    spiceLevel: null,
    sizes: { S: { base: 1230, tax: 1353 }, R: { base: 1280, tax: 1408 }, L: { base: 1380, tax: 1518 } },
  },
  {
    no: 11,
    name: "熟成ハラミステーキカレー",
    nameEn: "Aged Skirt Steak Curry",
    spiceLevel: null,
    sizes: { S: { base: 1330, tax: 1463 }, R: { base: 1380, tax: 1518 }, L: { base: 1480, tax: 1628 } },
  },
  {
    no: 12,
    name: "トロトロ角煮カレー",
    nameEn: "Braised Pork Belly Curry",
    spiceLevel: null,
    sizes: { S: { base: 1430, tax: 1573 }, R: { base: 1480, tax: 1628 }, L: { base: 1580, tax: 1738 } },
  },
  {
    no: 13,
    name: "ミックスフライカレー",
    nameEn: "Mixed Fried Curry",
    badge: "欲張りフライ！",
    spiceLevel: null,
    sizes: { S: { base: 1630, tax: 1793 }, R: { base: 1680, tax: 1848 }, L: { base: 1780, tax: 1958 } },
  },
  {
    no: 14,
    name: "ミックスグリルカレー",
    nameEn: "Mixed Grill Curry",
    badge: "背徳の…！",
    spiceLevel: null,
    sizes: { S: { base: 1830, tax: 2013 }, R: { base: 1880, tax: 2068 }, L: { base: 1980, tax: 2178 } },
  },
  {
    no: 15,
    name: "神戸ミナトマチ\nステーキカレー",
    nameEn: "Kobe Minatomachi Steak Curry",
    badge: "ごちそう豪快！",
    spiceLevel: null,
    sizes: { S: { base: 1930, tax: 2123 }, R: { base: 1980, tax: 2178 }, L: { base: 2080, tax: 2288 } },
  },
];

// サラダ
export const SALAD_MENU = {
  name: "本日のサラダ",
  nameEn: "Today's Salad",
  base: 250,
  tax: 275,
};

// サラダセット（カレーにプラス）
export const SALAD_SET_OPTION = {
  name: "サラダセット（+200円）",
  addBase: 200,
  addTax: 220,
};

// トッピング全10種類
export const TOPPING_MENU = [
  { no: 16, name: "玉子", nameEn: "Egg", base: 150, tax: 165 },
  { no: 17, name: "チーズ", nameEn: "Cheese", base: 150, tax: 165 },
  { no: 18, name: "ソーセージ1本", nameEn: "Sausage", base: 150, tax: 165 },
  { no: 19, name: "唐揚げ1ケ", nameEn: "Japanese Fried Chicken", base: 150, tax: 165 },
  { no: 20, name: "海老フライ1尾", nameEn: "Fried Shrimp", base: 200, tax: 220 },
  { no: 21, name: "チキンカツ", nameEn: "Chicken Cutlet", base: 250, tax: 275 },
  { no: 22, name: "牛すじ", nameEn: "Beef Tendon", base: 200, tax: 220 },
  { no: 23, name: "トロトロ角煮", nameEn: "Braised Pork Belly", base: 200, tax: 220 },
  { no: 24, name: "熟成ハラミ", nameEn: "Aged Skirt Steak", base: 300, tax: 330 },
  { no: 25, name: "ハンバーグ", nameEn: "Hamburger Steak", base: 400, tax: 440 },
];

// 価格帯サマリー（自動計算）
const curryTaxPrices = CURRY_MENU.flatMap((c) => [c.sizes.S.tax, c.sizes.R.tax, c.sizes.L.tax]);
const toppingTaxPrices = TOPPING_MENU.map((t) => t.tax);

export const PRICE_RANGE = {
  curryMin: Math.min(...curryTaxPrices),
  curryMax: Math.max(...curryTaxPrices),
  toppingMin: Math.min(...toppingTaxPrices),
  toppingMax: Math.max(...toppingTaxPrices),
};

// おすすめメニュー（トップページ掲載の6品）— CURRY_MENU の no と対応
export const RECOMMENDED_MENU_NOS = [1, 7, 10, 12, 14, 15];

export function findCurryByNo(no: number): CurryItem | undefined {
  return CURRY_MENU.find((c) => c.no === no);
}

// OPEN記念 半額フェア（プレスリリース記載・実データ）
// 対象：神戸名物ぼっかけカレー レギュラーサイズ
// ※2026-09-05 終了のため active: false（再開する場合は true に戻すだけでOK）
export const HALF_PRICE_PROMO = {
  active: false,
  title: "OPEN記念 半額フェア",
  targetCurryNo: 7, // 神戸名物ぼっかけカレー
  targetSize: "R" as const,
  regularTax: 1298, // 通常価格（税込）
  promoTax: 649, // 半額（税込）
  condition: "先着30食限定",
  period: "8月25日〜終了まで",
  note: "※なくなり次第終了となります。内容は変更となる場合がございます。",
};
